import { format, parse } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function formatCompetence(dateStr?: string | null): string {
  if (!dateStr) return 'N/D';
  try {
    return format(parse(dateStr, 'yyyy-MM-dd', new Date()), 'MM/yyyy', {
      locale: ptBR,
    });
  } catch {
    return dateStr;
  }
}
